'use client'

import { type Telop } from '@/types/interactiveVideo'
import { FC, useEffect, useState } from 'react'
import TelopDisplayPresentation from './TelopDisplayPresentation'

export interface TelopDisplayProps {
  telops?: Telop[]
  currentTime: number // 現在の再生時間（秒）
}

const TelopDisplay: FC<TelopDisplayProps> = ({ telops, currentTime }) => {
  const [activeTelop, setActiveTelop] = useState<Telop | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!telops || telops.length === 0) {
      setActiveTelop(null)
      setIsVisible(false)
      return
    }

    // 現在の時間に対応するテロップを探す
    const currentTelop = telops.find((telop) => currentTime >= telop.startTime && currentTime < telop.endTime)

    if (currentTelop) {
      // 新しいテロップが見つかった場合
      // 既存のテロップと異なる場合のみ更新（同じテロップの場合は継続表示）
      if (!activeTelop || activeTelop.text !== currentTelop.text || activeTelop.startTime !== currentTelop.startTime) {
        setActiveTelop(currentTelop)
        setIsVisible(true)
      }
    } else {
      // 表示すべきテロップがない場合
      setIsVisible(false)
      // 即座にクリア（連続するテロップのために遅延なし）
      setActiveTelop(null)
    }
  }, [telops, currentTime, activeTelop])

  return <TelopDisplayPresentation telop={activeTelop} isVisible={isVisible} />
}

export default TelopDisplay
